<script setup>
import AppMenu from "./AppMenu.vue";
import AppSidebarHeaderLogo from "./AppSidebarHeaderLogo.vue";

import { useLayout } from "@/layout/composables/layout";

const { layoutState, onSidebarToggle } = useLayout();

let timeout = null;

function onMouseEnter() {
  if (!layoutState.anchored) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    onSidebarToggle(true);
  }
}

function onMouseLeave() {
  if (!layoutState.anchored) {
    if (!timeout) {
      timeout = setTimeout(() => onSidebarToggle(false), 300);
    }
  }
}
</script>

<template>
  <div
    class="layout-sidebar bg-surface-50 !shadow-none dark:bg-surface-900 !border-none"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="sidebar-header relative flex justify-center items-center">
      <router-link to="/create" class="app-logo w-auto absolute top-3 left-6">
        <AppSidebarHeaderLogo />
      </router-link>
    </div>
    <div class="layout-menu-container flex flex-col h-full overflow-auto">
      <AppMenu />
    </div>
  </div>
</template>
